import { defineMessages } from "react-intl"

export const newsListMessages = defineMessages({
	allMarketplaces: {
		defaultMessage: "All markets",
		id: "newsList.allMarketplaces",
	},
	deleteEntry: {
		defaultMessage: "Delete entry",
		id: "newsList.deleteEntry",
	},
	deleteModalCancel: {
		defaultMessage: "Cancel",
		id: "newsList.deleteModal.cancel",
	},
	deleteModalConfirm: {
		defaultMessage: "Delete",
		id: "newsList.deleteModal.confirm",
	},
	deleteModalMessage: {
		defaultMessage: 'Do you really want to delete the entry "{title}"? This cannot be undone.',
		id: "newsList.deleteModal.message",
	},
	deleteModalTitle: {
		defaultMessage: "Delete entry",
		id: "newsList.deleteModal.title",
	},
	errorDeletingEntry: {
		defaultMessage: "An error occurred while deleting the news entry",
		id: "newsList.errorDeletingEntry",
	},
	errorLoadingEntries: {
		defaultMessage: "An error occurred while loading the news entries",
		id: "newsList.errorLoadingEntries",
	},
	headerMarkets: {
		defaultMessage: "Markets",
		id: "newsList.header.markets",
	},
	headerReviewStatus: {
		defaultMessage: "Review status",
		id: "newsList.header.reviewStatus",
	},
	headerStatus: {
		defaultMessage: "Status",
		id: "newsList.header.status",
	},
	headerTitle: {
		defaultMessage: "Title",
		id: "newsList.header.title",
	},
	headerUpdated: {
		defaultMessage: "Updated",
		id: "newsList.header.updated",
	},
	listCaption: {
		defaultMessage: "News entries",
		id: "newsList.caption",
	},
	navigation: {
		defaultMessage: "News Editor",
		id: "newsList.navigation",
	},
	newEntry: {
		defaultMessage: "New entry",
		id: "newsList.newEntry",
	},
	noEntries: {
		defaultMessage: "No news entries yet.",
		id: "newsList.noEntries",
	},
	pageSubtitle: {
		defaultMessage: "Manage news for dealers",
		id: "newsList.pageSubtitle",
	},
	pageTitle: {
		defaultMessage: "News Editor",
		id: "newsList.pageTitle",
	},
	reviewProgress: {
		defaultMessage: "{reviewed} of {total} reviewed",
		id: "newsList.reviewProgress",
	},
	statusDraft: {
		defaultMessage: "Draft",
		id: "newsList.status.draft",
	},
	statusPublished: {
		defaultMessage: "Published",
		id: "newsList.status.published",
	},
	statusReview: {
		defaultMessage: "Review",
		id: "newsList.status.review",
	},
})
